import { useState } from 'react';
import { TreeItemType } from '@api';
import { ItemInstanceType } from '@common';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table } from '@mantine/core';
import { FileItem, FolderItem } from './components';
import classes from './TreeItem.module.css';

type TreeItemPropsType = {
  item: ItemInstanceType<TreeItemType>;
  canWrite: boolean;
  onDelete: (item: TreeItemType) => void;
  onAddFolder: (parentId: string) => void;
  onAddFile: (folderId: string) => void;
};

export const TreeItem: React.FC<TreeItemPropsType> = ({
  item,
  canWrite,
  onDelete,
  onAddFolder,
  onAddFile,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const renderFolder = item.isFolder();

  const classname = item.isDragTarget() ? classes.dragTarget : '';

  return (
    <Table.Tr
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      h={55}
      className={`${classes.treeItem} ${classname} ${renderFolder ? classes.folderItem : ''}`}
      {...item.getProps()}
    >
      {canWrite ? (
        <Table.Td {...item.getDragHandleProps()}>
          <FontAwesomeIcon
            icon={faGripDotsVertical}
            className={classes.grabHandle}
          />
        </Table.Td>
      ) : (
        <Table.Td />
      )}
      {renderFolder ? (
        <FolderItem
          item={item}
          canWrite={canWrite}
          onAddFolder={() => onAddFolder(item.getItemMeta().itemId)}
          onAddFile={() => onAddFile(item.getItemMeta().itemId)}
          onDelete={onDelete}
          isHovered={isHovered}
        />
      ) : (
        <FileItem
          item={item}
          canWrite={canWrite}
          onDelete={onDelete}
          isHovered={isHovered}
        />
      )}
    </Table.Tr>
  );
};
